import { configureStore } from '@reduxjs/toolkit';
import eventReducer from './slices/eventSlice';
import urlParamsReducer from './slices/urlParamsSlice';
import uploadedContentReducer from './slices/uploadedContentSlice';

const APP_STATE_KEY = 'guestAppState';

// Load minimal app state from localStorage
const loadState = () => {
  try {
    const serializedState = localStorage.getItem(APP_STATE_KEY);
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return undefined;
  }
};

// Save only lightweight state to localStorage
const saveState = (state) => {
  try {
    const serializedState = JSON.stringify({
      urlParams: state.urlParams,
    });
    localStorage.setItem(APP_STATE_KEY, serializedState);
  } catch (err) {
    // Ignore write errors
  }
};

const store = configureStore({
  reducer: {
    events: eventReducer,
    urlParams: urlParamsReducer,
    uploadedContent: uploadedContentReducer,
  },
  preloadedState: loadState(),
});

// Subscribe to store changes and save to localStorage
store.subscribe(() => {
  saveState(store.getState());
});

export default store; 